import React from "react";

import HelpIcon from "@mui/icons-material/Help";
import { Avatar, Tooltip } from "@mui/material";
import clsx from "clsx";

import mainStyles from "../../styles";
import { privilegeDisplays } from "helpers/privileges";

interface DisplayPrivilegeIconProps {
  privilegeName: string;
}

const DisplayPrivilegeIcon = ({ privilegeName }: DisplayPrivilegeIconProps) => {
  const classes = mainStyles();

  const privilegeDisplay = privilegeDisplays.find(
    (p) => p.privilege === privilegeName,
  );
  return (
    <Tooltip
      title={privilegeDisplay?.privilegeName || "Unknown Privilege"}
      placement="bottom"
      data-testid={"privileges-tooltip"}
    >
      <Avatar
        variant="rounded"
        style={{
          width: "30px",
          height: "30px",
          marginRight: "5px",
          backgroundColor: privilegeDisplay?.iconColour,
        }}
        className={clsx(classes.purpleRain)}
        data-testid={"privileges-avatar"}
      >
        {privilegeDisplay?.component || (
          <HelpIcon fontSize="small" data-testid={"unknown-privileges-icon"} />
        )}
      </Avatar>
    </Tooltip>
  );
};

export default DisplayPrivilegeIcon;
